// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/fonts/GTEestiBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/fonts/AvenirBook.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/fonts/AvenirBlack.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/fonts/AvenirOblique.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*******************************************************
 *                                                     *
 *                VIAJES TEIDE                         *
 *                                                     *
 *        developed: Javier Vega Martinez              *
 *        contact: info@emdbwebprojects.com            *
 *        copyright - 2014-2024                        *
 *                                                     *
 *******************************************************/
/* width */
/* fonts */
@font-face {
  font-family: GTEestiBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: AvenirBook;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: AvenirBlack;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: AvenirOblique;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
/* debug */
.debug-vZ8g8 {
  background-color: #ff7f50;
}
.debug2-odVF5 {
  background-color: #6495ed;
}
.meetingpoint-ouMfE {
  box-sizing: border-box;
  padding: 8px 20px;
  font-family: "AvenirBook";
}
.meetingpoint-ouMfE .title-dsRAy {
  margin-bottom: 10px;
  padding-top: 10px;
  font-size: 1.125em;
  border-top: 2px solid #E1E1E1;
}
.meetingpoint-ouMfE .infocontent-R21FO {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
.meetingpoint-ouMfE .infocontent-R21FO .select-Kh7Eu {
  flex: 1;
  min-width: 250px;
}
.meetingpoint-ouMfE .infocontent-R21FO .info-C6b2a {
  flex: 1;
  min-width: 250px;
}
.meetingpoint-ouMfE .infocontent-R21FO .info-C6b2a .maplink-Cqxph {
  font-size: 1.125em;
  cursor: pointer;
}
.meetingpoint-ouMfE .infocontent-R21FO .info-C6b2a .maplink-Cqxph .mapicon-MaNOK {
  vertical-align: middle;
  margin-right: 10px;
}
.meetingpoint-ouMfE .infocontent-R21FO .info-C6b2a .maplink-Cqxph a {
  color: #33CCFF;
  text-decoration: none;
}
.meetingpoint-ouMfE .infocontent-R21FO .info-C6b2a .maplink-Cqxph a:hover {
  text-decoration: underline;
}
.meetingpoint-ouMfE .map-reyhc {
  width: 100%;
  height: 300px;
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/VTForm/components/VTMeetingPoint/VTMeetingPoint.module.less","webpack://./src/assets/css/theme.less"],"names":[],"mappings":"AAAA;;;;;;;;wDAQwD;AACxD,UAAU;AACV,UAAU;ACwBV;EAAY,wBAAA;EAA0B,4CAAA;ADpBtC;ACqBA;EAAY,uBAAA;EAAyB,4CAAA;ADjBrC;ACkBA;EAAY,wBAAA;EAA0B,4CAAA;ADdtC;ACeA;EAAY,0BAAA;EAA4B,4CAAA;ADXxC;AACA,UAAU;ACiBV;EAAQ,yBAAA;ADdR;ACeA;EAAS,yBAAA;ADZT;AA/BA;EAAe,sBAAA;EAAwB,iBAAA;EAAkB,yBAAA;AAoCzD;AApCA;EACS,mBAAA;EAAqB,iBAAA;ECqC5B,kBAAA;EDrC+D,6BAAA;AAyCjE;AA1CA;EAEe,aAAA;EAAc,SAAA;EAAU,eAAA;EAAiB,WAAA;EAAa,WAAA;EAAY,YAAA;AAgDjF;AAlDA;EAGY,OAAA;EAAQ,gBAAA;AAmDpB;AAtDA;EAKU,OAAA;EAAQ,gBAAA;AAqDlB;AA1DA;ECsCE,kBAAA;EDhC6B,eAAA;AAwD/B;AA9DA;EAOiB,sBAAA;EAAwB,kBAAA;AA2DzC;AAlEA;EAQU,cAAA;EAAmB,qBAAA;AA8D7B;AAtEA;EASgB,0BAAA;AAgEhB;AAzEA;EAaO,WAAA;EAAa,aAAA;EAAe,gBAAA;AAiEnC","sourcesContent":["@import \"../../../../assets/css/theme\";\n\n.meetingpoint {box-sizing: border-box; padding:8px 20px; font-family:\"AvenirBook\";\n  .title{margin-bottom: 10px; padding-top: 10px; .font-base(18); border-top:2px solid @colorgris1;}\n  .infocontent{display:flex; gap:20px; flex-wrap: wrap; width: 100%; margin:0px; padding:0px;\n    .select{flex:1; min-width: 250px;\n    }\n    .info{flex:1; min-width: 250px;\n      .maplink{.font-base(18); cursor: pointer;\n        .mapicon{vertical-align: middle; margin-right: 10px;}\n        a{color:@colorazul1; text-decoration: none;}\n        a:hover{text-decoration: underline;}\n      }\n    }\n  }\n  .map{width: 100%; height: 300px; margin-top:20px;\n\n\n  }\n\n\n}\n\n","/*******************************************************\n *                                                     *\n *                VIAJES TEIDE                         *\n *                                                     *\n *        developed: Javier Vega Martinez              *\n *        contact: info@emdbwebprojects.com            *\n *        copyright - 2014-2024                        *\n *                                                     *\n *******************************************************/\n\n//VARS\n\n@colorverde1: #99CC33;  //verde 1\n@colorverde2: #009933;  //verde 2\n@colorverde3: #BEE266;  //verde 3\n@colorazul1: #33CCFF;   //azul 1\n@colorrosa1: #FF6698;   //rosa 1\n\n@colorgris1: #E1E1E1;   //Gris background footer\n@colorgris2: #999999;   //Gris text\n@colorgris3: #666666;   //Gris text\n@colorgris4: #333333;   //Gris text\n@colorgris5: #5D5D5D;\n\n/* width */\n@width-space:20px;\n@width-column:40px;\n@width-content: 1100px;\n@width-total: @width-content + 20px;\n@width-min:400px;\n\n/* fonts */\n@em:16px;\n\n@font-face {font-family: GTEestiBold; src: url('../fonts/GTEestiBold.otf'); }\n@font-face {font-family: AvenirBook; src: url('../fonts/AvenirBook.otf'); }\n@font-face {font-family: AvenirBlack; src: url('../fonts/AvenirBlack.ttf'); }\n@font-face {font-family: AvenirOblique; src: url('../fonts/AvenirOblique.otf'); }\n\n.font-base(@sizeValue) {\n  font-size: unit(( @sizeValue / @em ), em);\n}\n\n/* debug */\n.debug {background-color:#ff7f50;}\n.debug2 {background-color:#6495ed ;}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"debug": `debug-vZ8g8`,
	"debug2": `debug2-odVF5`,
	"meetingpoint": `meetingpoint-ouMfE`,
	"title": `title-dsRAy`,
	"infocontent": `infocontent-R21FO`,
	"select": `select-Kh7Eu`,
	"info": `info-C6b2a`,
	"maplink": `maplink-Cqxph`,
	"mapicon": `mapicon-MaNOK`,
	"map": `map-reyhc`
};
export default ___CSS_LOADER_EXPORT___;
